/* eslint-disable max-params */
import deepmerge from 'deepmerge';

export const loadData = async function (endpoint, options, normalize = true, rethrow = true, noHeaders = false) {
  const defaultOptions = {
    method: 'GET',
    headers: noHeaders
      ? {}
      : {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
        },
    credentials: 'include',
  };
  options = deepmerge(defaultOptions, options);

  let response;
  try {
    response = await fetch(endpoint, options);
  } catch (e) {
    throw new Error('Request was cancelled.');
  }

  if (rethrow && response.status >= 400) {
    const error = new Error(`${response.status}: ${response.statusText} received from ${endpoint}`);
    error.response = response;
    throw error;
  }
  // Response OK (No-Content) - return response without serialization
  if (response.status === 204) {
    return response;
  }

  try {
    const json = await response.json();

    if (normalize) {
      const data = json.data ?? json;
      const normalizeObject = val => Object.assign({ id: val.id, type: val.type }, val.attributes);
      return Array.isArray(data) ? data.map(normalizeObject) : normalizeObject(data);
    }

    // This data should already be normalized. No need to normalize normalized data.
    return json;
  } catch (e) {
    // response must not be json, throw an object that matches redux-json-api errors
    throw { response };
  }
};

export const loadApiData = async function (endpoint, normalize) {
  return await requestApiData(endpoint, normalize);
};

export const loadExternalData = async function (endpoint, authToken, normalize) {
  return await requestExternalData(endpoint, authToken, normalize);
};

export const requestApiData = async function (endpoint, normalize, method = 'GET', options = {}, rethrow = true) {
  const tokenMeta = document.querySelector('meta[name=csrf-token]');
  const csrfToken = tokenMeta ? tokenMeta.attributes.content.value : '';

  const defaultOptions = {
    method,
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'include',
  };
  options = deepmerge(defaultOptions, options);

  return await loadData(endpoint, options, normalize, rethrow);
};

export const requestExternalData = async function (
  endpoint,
  authToken,
  normalize,
  method = 'GET',
  options = {},
  rethrow = true,
  noHeaders = false
) {
  const defaultOptions = {
    method,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  options = deepmerge(defaultOptions, options);

  return await loadData(endpoint, options, normalize, rethrow, noHeaders);
};
